<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="20">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>   
          <el-col :span="3">
          <el-select placeholder="请选择业务部门" v-model="query.department" filterable clearable @change="handleSearch">
            <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
          </el-select>
          </el-col>         
          <el-col :span="2">
            <span>
              <el-button type="primary" size="small"  @click="doExport">导出转移记录</el-button>
            </span>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" size="small"  @click="shipQuitExport">退会/变更申请书（正常）</el-button>
          </el-col>

        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <!-- 客户名称 -->
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column align="left" label="转让人">
              <template slot-scope="scope">
                <span>{{scope.row.member_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="接收人">
              <template slot-scope="scope">
                <span>{{scope.row.recipient_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="船名">
              <template slot-scope="scope">
                <span>{{scope.row.ship_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="新船名">
              <template slot-scope="scope">
                <span>{{scope.row.new_ship_name}}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="业务归属部门">
              <template slot-scope="scope">
                <span>{{scope.row.department}}</span>
              </template>
            </el-table-column>

       
            <!-- 更新人 -->
            <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 申请时间 -->
            <el-table-column align="left" label="申请时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="转让金额">
              <template slot-scope="scope">
                <span>{{ scope.row.balance }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="状态">
              <template slot-scope="scope">
                <span>{{ scope.row.status_name}}</span>
              </template>
            </el-table-column>

        
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="提交审核" placement="top-start" v-show="[0,2].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleSubmit(scope.row)">
                    <i class="el-icon-s-promotion"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="审核" placement="top-start" v-if="scope.row.status === 3  && $perm(['member.move_account'])">
                    <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>

                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" placement="top-start" content="查看">
                    <el-button type="text" @click="handleUpdate(scope.row)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="修改转移金额" placement="top-start" v-show="[0,2].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleUpdateMoney(scope.row)">
                    <svg-icon icon-class="edit"></svg-icon>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
            <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              object-type="member.accounttransfer"
              :object-id="apply_id"
              :ship-list="shipList" 
              :customer-list="customerList"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
          <el-dialog :visible.sync="shipQuitVisible" width="50%" title="导出船舶退会/变更申请书">
      <el-form ref="dataForm" :model="quitForm" label-position="top" label-width="120px" class="mx-30">
        <el-form-item label="请选择退会原因" >
          <el-radio v-model="quitForm.reason" label="1">报废</el-radio>
          <el-radio v-model="quitForm.reason" label="2">转让</el-radio>
          <el-radio v-model="quitForm.reason" label="3">其他</el-radio>
        </el-form-item>
        <el-form-item label="其他原因" v-show="quitForm.reason === '3'">
          <el-input  type="textarea" :rows="4" placeholder="请输入其他原因"  v-model="quitForm.other_reason" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="请选择退会类型">
          <el-radio v-model="quitForm.type" label="1" disabled>仅退船舶保留风险准备金</el-radio>
          <el-radio v-model="quitForm.type" label="2" disabled>转移风险准备金</el-radio>
          <el-radio v-model="quitForm.type" label="3" disabled>退风险准备金</el-radio>
        </el-form-item>
        <el-form-item label="请选择开票类型"  v-show="quitForm.type === '3' && export_type === 2">
          <el-radio v-model="quitForm.invoice_type" label="1">专票</el-radio>
          <el-radio v-model="quitForm.invoice_type" label="2">普票</el-radio>
        </el-form-item>
        <el-form-item label="开票金额" v-show="quitForm.type === '3'  && export_type === 2">
          <el-input  type="number" :rows="4" placeholder="请输入开票金额"  v-model="quitForm.quit_amount" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="扣减税额" v-show="quitForm.type === '3'  && export_type === 2">
          <el-input  type="number" :rows="4" placeholder="请输入扣减税额"  v-model="quitForm.tax" style="width: 65%;"/> 
        </el-form-item>
        <el-form-item label="签署日期">
              <el-date-picker
                v-model="quitForm.write_date"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
        </el-form-item>
    
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelShipQuitVisible">取消</el-button>
        <el-button type="primary" @click="exportShipQuit">导出</el-button>
      </span>
    </el-dialog>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import UploadDialog from "@/components/UploadDialog"
    import { fetchFileTypeList } from "@/api/common"
    import { fetchList as fetchGroupList } from "@/api/group";
    import {rejectTransferApply,exportShipQuitApply,transferList,exportShipTransfer,SubmitTransferApply} from '@/api/member'
  
    export default {
      name: "applyList",
      components: {
        PaginationNew,
        UploadDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          groupList:[],
          object_name:"",
          apply_id:'',
          quitForm:{},
          file_type_list:[],
          customerList:[],
          shipList:[],
          query: {
            search: '',
            offset: 0,
            limit: 20,
          },
          searching: false,
          listLoading: false,
          shipQuitVisible:false,
          loadingText: '正在加载船东数据，请稍等...',
          total: 0,
        }
      },
      methods: {
        exportShipQuit(){
          if ( !this.quitForm.reason ) {
                this.$error_message("请选择退会原因！")
                return
              }
          if ( !this.quitForm.type ) {
            this.$error_message("请选择退会类型！")
            return
          }
          exportShipQuitApply({type:this.export_type,data:this.multipleSelection,reason:this.quitForm})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "船舶退会/变更申请书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.assignVisible = false
                this.downloading = false
            })
            .catch(error => {
                this.downloading = false
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })

        },
        shipQuitExport(){
          if (this.multipleSelection.length !== 1) {
                this.$error_message("请选择一条转让申请！")
                return
              }       
          this.quitForm.type = '2'
          this.export_type = 1
          this.shipQuitVisible = true
        },
     
        cancelShipQuitVisible(){
          this.shipQuitVisible = false
          this.quitForm = {}
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "cc|bc|sc"}))
          p.push(fetchGroupList())

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
            this.groupList = res[1]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          let customer_obj = {"id":row.recipient_id,"name":row.recipient_name}
          this.customerList.push(customer_obj)
          let ship_obj = {"id":row.ship,"name":row.ship_name}
          this.shipList.push(ship_obj)
          if (row.new_ship){
              this.shipList.push({"id":row.new_ship,"name":row.new_ship_name})
          }
          this.apply_id = row.id
          this.object_name = row.ship_name
          this.$refs.upload.handleOpen()
        },
        handleSubmit(row) {
            this.$confirm('提交审核后，将不能再修改, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              SubmitTransferApply({id: row.id})
              .then(res => {
                this.$message.success(res)
                this.getList()
              })
              .catch(err => {
                this.$error_message(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          },
        doExport: function(){
          exportShipTransfer()
          .then(res=>{
            let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.download = '船舶转移记录' + '.xlsx'
            document.body.appendChild(link)

            link.click()
            URL.revokeObjectURL(blob)
            document.body.removeChild(link)
          }).catch(err =>{
            this.$error_message(err)
          })
      },
        handleReject(row) {
          var msg = '是否拒绝该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            rejectTransferApply({'id':row.id})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '拒绝成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        handleSuccess(row) {
          this.setQueryStorage()
          this.$router.push({ name: 'TransferApplyDetail', query: {'type': 'TransferApply', 'id': row.id}})
        },
        handleUpdate(row){
          this.setQueryStorage()
          this.$router.push({ name: 'TransferApplyDetail', query: {'type': 'ViewTransferApply', 'id': row.id}})
        },
        handleUpdateMoney(row){
          this.setQueryStorage()
          this.$router.push({ name: 'TransferApplyDetail', query: {'type': 'UpdateTransferApply', 'id': row.id}})
        },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        handleSearch() {
          this.getList()
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          transferList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20
            
          }
        this.getList()
        this.loadData()
      }
    }
  </script>
  